module.exports = __webpack_public_path__ + "img/wallet-money.d6b75f32.svg";